"use strict";
import axios from 'axios';
import imagesLoaded from 'imagesloaded';
import * as slider from './slider.js';
import * as ad from './ad.js';

export function initialize() {
  const originArticle = document.getElementById('originArticle');
  const articleInfiniteOriginPath = originArticle.dataset.infinitePvPath;
  const placeHolder = document.getElementById('placeHolder');
  let firstVirtualPvFlag = true;

  function initializeInfinite() {
    const infinityListElement = document.getElementById('infinityList');

    if (infinityListElement === null) {
      return false;
    }

    const infinityList = JSON.parse(infinityListElement.textContent);
    const infinityListLength = infinityList.length;

    let infinityIndex = 0;

    console.log("Ã£ÂÂ­Ã£ÂÂ¼Ã£ÂÂÃ£ÂÂÃ£ÂÂÃ¨Â¨ÂÃ¤ÂºÂÃ£ÂÂ¯" + infinityListLength + "Ã¤Â»Â¶Ã£ÂÂ§Ã£ÂÂÃ£ÂÂÃ£ÂÂ" + infinityList);

    const infinityLoadObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          if (entry.boundingClientRect.top > 0) {
            let isLastQuery = isLastArticle() ? '&isLast=true' : '';
            let uri = '/article/body/?id=' + infinityList[infinityIndex] + '&number=' + (infinityIndex + 1) + isLastQuery;
            console.log((infinityIndex + 1) + "Ã¥ÂÂÃ§ÂÂ®Ã£ÂÂ" + uri + "Ã£ÂÂ«Ã£ÂÂªÃ£ÂÂ¯Ã£ÂÂ¨Ã£ÂÂ¹Ã£ÂÂÃ¤Â¸Â­...");

            axios.get(uri)
              .then(function (response) {
                let loadedArticleContainer = document.createElement('div');
                loadedArticleContainer.innerHTML = response.data;
                placeHolder.insertAdjacentElement('beforebegin', loadedArticleContainer);
                slider.infinitiSlideInit();
                ad.addNewAd();
                initializeInfinitePvObserver();
                initializeVirtualPvObserver();
                console.log(infinityList[infinityIndex] + "Ã¨Â¨ÂÃ¤ÂºÂÃ£ÂÂ®Ã¨Â¿Â½Ã¥ÂÂ Ã£ÂÂÃ¥Â®ÂÃ¤ÂºÂÃ£ÂÂÃ£ÂÂ¾Ã£ÂÂÃ£ÂÂÃ£ÂÂ");

                if (isLastArticle()) {
                  console.log("Ã¦ÂÂÃ¥Â¾ÂÃ£ÂÂ®Ã¨Â¨ÂÃ¤ÂºÂÃ£ÂÂ¯Ã§ÂÂ£Ã¨Â¦ÂÃ£ÂÂÃ£ÂÂ¾Ã£ÂÂÃ£ÂÂÃ£ÂÂ");
                  return false;
                }

                let article = loadedArticleContainer.getElementsByTagName("article");
                infinityLoadObserver.observe(article[0]);
                infinityIndex = infinityIndex + 1;
              })
              .catch(function (error) {
                console.log("Ã¨Â¨ÂÃ¤ÂºÂÃ£ÂÂ®Ã¥ÂÂÃ¥Â¾ÂÃ£ÂÂ«Ã¥Â¤Â±Ã¦ÂÂÃ£ÂÂÃ£ÂÂ¾Ã£ÂÂÃ£ÂÂÃ£ÂÂ")
              })
          }
        }
      });
    }, {
      rootMargin: '200% 0%',
      threshold: 0.2
    });

    function isLastArticle() {
      return infinityIndex + 1 === infinityListLength;
    }

    infinityLoadObserver.observe(originArticle);
  }

  function initializeInfinitePvObserver() {
    let article = document.querySelectorAll('[data-infinite-pv-path]');
    const infinitePvObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          let path = new URL(entry.target.dataset.infinitePvPath).pathname;
          let originPath = new URL(articleInfiniteOriginPath).pathname;
          let title = entry.target.dataset.infinitePvTitle;

          document.title = title;
          window.history.pushState(null,null, path);

          if (path === originPath) {
            return false;
          }

          console.log("Ã¤Â»Â®Ã¦ÂÂ³Ã£ÂÂ¤Ã£ÂÂ³Ã£ÂÂÃ£ÂÂ£Ã£ÂÂÃ£ÂÂÃ£ÂÂ£PVÃ£ÂÂÃ©ÂÂÃ¤Â¿Â¡Ã£ÂÂÃ£ÂÂ¾Ã£ÂÂÃ£ÂÂ" + path);
          dataLayer.push({
            "articleInfiniteOriginPath": originPath,
            "articleInfiniteNumber": entry.target.dataset.articleInfiniteNumber,
            "event": 'infinitePV',
            "pageVirtual": 'Ã£ÂÂ¤Ã£ÂÂ³Ã£ÂÂÃ£ÂÂ£Ã£ÂÂÃ£ÂÂÃ£ÂÂ£Ã£ÂÂ¹Ã£ÂÂ¯Ã£ÂÂ­Ã£ÂÂ¼Ã£ÂÂ«',
            "infinitePVpath": path,
            "infinitePVtitle": title
          });
        }
      });
    }, {
      rootMargin: "0px",
      threshold: 0.2
    });

    article.forEach(function(components) {
      infinitePvObserver.observe(components);
    });
  }

  function initializeVirtualPvObserver() {
    const virtualPvElements = document.querySelectorAll('[data-vpvpath]');
    const virtualPvObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          if (entry.boundingClientRect.top > 0) {
            let path = new URL(entry.target.dataset.vpvpath).pathname;
            let query = new URL(window.location.href).search;
            let beforePath = location.pathname;

            if (firstVirtualPvFlag === true) {
              //console.log("Ã£ÂÂÃ£ÂÂ¼Ã£ÂÂ¸Ã¦ÂÂÃ¤Â¸ÂÃ©ÂÂ¨Ã£ÂÂ®Ã¤Â»Â®Ã¦ÂÂ³PVÃ£ÂÂ«Ã£ÂÂ¦Ã£ÂÂ³Ã£ÂÂÃ£ÂÂ1Ã¥ÂÂÃ§ÂÂ¡Ã¨Â¦ÂÃ£ÂÂÃ£ÂÂ¾Ã£ÂÂÃ£ÂÂ");

              firstVirtualPvFlag = false;
              return false;
            }
            if (path === beforePath) return false;

            beforePath = path;
            path += query;
            console.log("Ã¤Â»Â®Ã¦ÂÂ³PVÃ£ÂÂÃ©ÂÂÃ¤Â¿Â¡Ã£ÂÂÃ£ÂÂ¾Ã£ÂÂÃ£ÂÂ" + path);
            window.history.replaceState(null,null, path);
            dataLayer.push({
              "event": 'articleVirtualPV',
              "pageVirtual": 'Ã£ÂÂ¹Ã£ÂÂ¯Ã£ÂÂ­Ã£ÂÂ¼Ã£ÂÂ«',
              "VPVpath": path
            });
          }
        }
      });
    }, {
      rootMargin: "0px",
      threshold: 0
    });

    virtualPvElements.forEach(function(components) {
      virtualPvObserver.observe(components);
    });
  }

  imagesLoaded( document.querySelector('.article-container'), function () {
    initializeVirtualPvObserver();
    //initializeInfinite();
    //initializeInfinitePvObserver();
  });
}
